import { render, staticRenderFns } from "./DoctorCardD.vue?vue&type=template&id=088ec9d0&scoped=true"
import script from "./DoctorCardD.vue?vue&type=script&lang=js"
export * from "./DoctorCardD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088ec9d0",
  null
  
)

export default component.exports